<template>
  <div>
    <table class="course-history-table">
      <thead>
        <tr>
          <th></th>
          <th>Tutor Name</th>
          <th>Total Sub</th>
          <th>Last Subs Taught</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="waitings.length === 0">
          <td class="no-data" colspan="8">No data available</td>
        </tr>
        <tr
          v-for="waiting of waitings"
          :key="waiting.tutor.id"
        >
          <td>
            <input
              name="select-tutor"
              type="radio"
              @click="selectedTutor = waiting.tutor"
            >
          </td>
          <td>{{ waiting.tutor.name }}</td>
          <td>{{ waiting.substituteCount }}</td>
          <td>{{ waiting.latestSubstituteDate | ymd | empty }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { periodType } from '@/store/common.types'
import { Tutor } from '@/store/tutors/types'
import { Waiting } from '@/store/waitings/types'
import { Moment } from 'moment'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  filters: {
    ymd: (date: Moment|null) => date && date.format('YYYY/MM/DD'),
    empty: (s: string) => s || '-----',
  },
})
export default class WaitingTutorList extends Vue {
  @Prop({ required: true }) date!: Moment

  @Prop({ required: true }) period!: periodType

  @Prop() value!: Tutor

  created() {
    this.$store.dispatch('fetchWaitings', {
      date: this.date,
      period: this.period,
    });
  }

  private get waitings(): Waiting[] {
    return this.$store.state.waitings.waitings
  }

  private get selectedTutor(): Tutor {
    return this.value
  }

  private set selectedTutor(tutor: Tutor) {
    this.$emit('input', tutor)
  }
}
</script>

<style scoped>

table.course-history-table {
  width:100%;
  border-collapse:collapse;
  background: #fff;
  margin-bottom:10px;
}

table.course-history-table thead tr {
  background:#DBDBDB
}

table.course-history-table tr {
  border: 2px solid #DBDBDB
}

table.course-history-table thead th, table.course-history-table thead td {
  padding: 20px;
  text-align: center;
}

table.course-history-table thead th, table.course-history-table td {
  border-right:2px solid #DBDBDB;
}

table.course-history-table td {
  height: 50px;
  padding:10px 20px;
  text-align: center;
}

</style>
